var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { linearSpace } from '@openchemistry/utils';
import { splineEval } from '../utils/spline';

var DataProvider =
/** @class */
function () {
  function DataProvider() {
    this.arrays = {};
    this.labels = {};

    if (this.constructor == DataProvider) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }

  DataProvider.prototype.getArray = function (key) {
    return this.arrays[key] || [];
  };

  DataProvider.prototype.getKeys = function () {
    return Object.keys(this.arrays);
  };

  DataProvider.prototype.getLabel = function (key) {
    return this.labels[key] || key;
  };

  DataProvider.prototype.setLabel = function (key, label) {
    this.labels[key] = label;
  };

  DataProvider.prototype.hasKey = function (key) {
    return key in this.arrays;
  };

  DataProvider.prototype.removeArray = function (key) {
    var deleted = key in this.arrays;
    delete this.arrays[key];
    delete this.labels[key];
    return deleted;
  };

  DataProvider.prototype.setArray = function (_key, _data) {
    throw new Error("setArray method must be implemented");
  };

  return DataProvider;
}();

var ArrayDataProvider =
/** @class */
function (_super) {
  __extends(ArrayDataProvider, _super);

  function ArrayDataProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ArrayDataProvider.prototype.setArray = function (key, data) {
    this.arrays[key] = data;
  };

  return ArrayDataProvider;
}(DataProvider);

export { ArrayDataProvider };

var SplineDataProvider =
/** @class */
function (_super) {
  __extends(SplineDataProvider, _super);

  function SplineDataProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.splines = {};
    _this.nPoints = 300;
    return _this;
  }

  SplineDataProvider.prototype.getArray = function (key) {
    if (key in this.arrays && this.arrays[key] === null) {
      var x = linearSpace(0, 1, this.nPoints, false);
      this.arrays[key] = splineEval(x, this.splines[key]);
    }

    return _super.prototype.getArray.call(this, key);
  };

  SplineDataProvider.prototype.setArray = function (key, data) {
    this.splines[key] = data;
    this.arrays[key] = null;
  };

  SplineDataProvider.prototype.removeArray = function (key) {
    delete this.splines[key];
    return _super.prototype.removeArray.call(this, key);
  };

  SplineDataProvider.prototype.setPoints = function (n) {
    if (n === this.nPoints) {
      return;
    }

    this.nPoints = n;

    for (var key in this.arrays) {
      this.arrays[key] = null;
    }
  };

  return SplineDataProvider;
}(DataProvider);

export { SplineDataProvider };